<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>
  <main class="container py-4">

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="fw-bold mb-0">KYC Review Details</h4>
        <div class="text-muted small">Review fields, documents, and decision actions</div>
      </div>

      <button class="btn btn-outline-secondary btn-sm" (click)="back()">
        Back
      </button>
    </div>

    <div *ngIf="loading" class="text-center py-4">
      <div class="spinner-border"></div>
    </div>

    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div>

    <ng-container *ngIf="!loading && application as app">

      <div class="card shadow-sm border-0 mb-4">
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-3">
              <div class="text-muted small">User</div>
              <div class="fw-semibold">{{ app.fullName }}</div>
              <div class="small text-muted">{{ app.email }}</div>
            </div>

            <div class="col-md-3">
              <div class="text-muted small">Country</div>
              <div class="fw-semibold">{{ app.jurisdictionCode }}</div>
            </div>

            <div class="col-md-2">
              <div class="text-muted small">Tier</div>
              <div class="fw-semibold">{{ app.tierCode }}</div>
            </div>

            <div class="col-md-2">
              <div class="text-muted small">Product</div>
              <div class="fw-semibold">{{ app.productType }}</div>
            </div>

            <div class="col-md-2">
              <div class="text-muted small">Status</div>
              <span class="badge" [ngClass]="getStatusClass(app.status)">
                {{ app.status }}
              </span>
            </div>
          </div>

          <div class="row g-3 mt-1">
            <div class="col-md-3" *ngIf="app.startedAt">
              <div class="text-muted small">Started</div>
              <div class="fw-semibold">{{ app.startedAt | date:'medium' }}</div>
            </div>

            <div class="col-md-3" *ngIf="app.submittedAt">
              <div class="text-muted small">Submitted</div>
              <div class="fw-semibold">{{ app.submittedAt | date:'medium' }}</div>
            </div>

            <div class="col-md-3" *ngIf="app.approvedAt">
              <div class="text-muted small">Approved</div>
              <div class="fw-semibold">{{ app.approvedAt | date:'medium' }}</div>
            </div>

            <div class="col-md-3" *ngIf="app.rejectedAt">
              <div class="text-muted small">Rejected</div>
              <div class="fw-semibold">{{ app.rejectedAt | date:'medium' }}</div>
            </div>
          </div>

          <div *ngIf="app.reviewNotes" class="alert alert-warning mt-3 mb-0">
            <strong>Review notes:</strong> {{ app.reviewNotes }}
          </div>
        </div>
      </div>

      <div class="card shadow-sm border-0 mb-4" *ngIf="app.thirdParty">
        <div class="card-body">

          <div class="d-flex justify-content-between align-items-start mb-3">
            <div>
              <h5 class="mb-0">Third Party Verification</h5>
              <div class="text-muted small">Third party customer verification status</div>
            </div>

            <div class="d-flex align-items-center gap-2">
              <span class="badge" [ngClass]="getStatusClass(app.thirdParty.status || '')">
                {{ app.thirdParty.status || 'Not Submitted' }}
              </span>

              <button class="btn btn-outline-primary btn-sm" [disabled]="actionLoading"
                (click)="syncThirdPartyVerification()">
                Sync Status
              </button>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-md-3">
              <div class="text-muted small">Provider</div>
              <div class="fw-semibold">{{ app.thirdParty.providerCode || '-' }}</div>
            </div>

            <div class="col-md-3">
              <div class="text-muted small">Customer Reference</div>
              <div class="fw-semibold text-break">{{ app.thirdParty.reference || '-' }}</div>
            </div>

            <div class="col-md-3" *ngIf="app.thirdParty.submittedAt">
              <div class="text-muted small">Submitted To Provider</div>
              <div class="fw-semibold">{{ app.thirdParty.submittedAt | date:'medium' }}</div>
            </div>

            <div class="col-md-3" *ngIf="app.thirdParty.verifiedAt">
              <div class="text-muted small">Verified At</div>
              <div class="fw-semibold">{{ app.thirdParty.verifiedAt | date:'medium' }}</div>
            </div>
          </div>

          <div *ngIf="app.thirdParty.rejectionReason" class="alert alert-danger mt-3 mb-0">
            <strong>Third party rejection reason:</strong>
            {{ app.thirdParty.rejectionReason }}
          </div>
        </div>
      </div>

      <div class="card shadow-sm border-0 mb-4">
        <div class="card-body">
          <h5 class="mb-3">Application Decision</h5>

          <div class="mb-3">
            <label class="form-label">Review Notes</label>
            <textarea class="form-control" rows="3" [(ngModel)]="reviewNotes"></textarea>
          </div>

          <div class="mb-3">
            <label class="form-label">Rejection Reason</label>
            <textarea class="form-control" rows="3" [(ngModel)]="rejectionReason"></textarea>
          </div>

          <div class="d-flex flex-wrap gap-2">
            <button class="btn btn-outline-primary btn-sm"
              [disabled]="actionLoading || app.status === 'PendingThirdPartyVerification' || app.status === 'ThirdPartyRejected' || app.status === 'Approved' || app.status === 'Rejected'"
              (click)="startReview()">
              Start Review
            </button>

            <button class="btn btn-success btn-sm"
              [disabled]="actionLoading || app.status === 'PendingThirdPartyVerification' || app.status === 'ThirdPartyRejected' || app.status === 'Approved' || app.status === 'Rejected'"
              (click)="approveApplication()">
              Approve Application
            </button>

            <button *ngIf="app.status === 'Approved'" class="btn btn-warning btn-sm" type="button"
              [disabled]="actionLoading || reopening" (click)="openReopenModal()">
              Reopen Application
            </button>

            <button class="btn btn-danger btn-sm"
              [disabled]="actionLoading || app.status === 'Approved' || app.status === 'Rejected'"
              (click)="rejectApplication()">
              Reject Application
            </button>
          </div>
        </div>
      </div>

      <div class="row g-4">
        <div class="col-lg-6">
          <div class="card shadow-sm border-0 h-100">
            <div class="card-body">
              <h5 class="mb-3">Field Values</h5>

              <div *ngIf="!app.fields?.length" class="text-muted small">
                No field values submitted.
              </div>

              <div *ngFor="let field of app.fields; trackBy: trackByField" class="border-bottom py-2">
                <div class="text-muted small">{{ field.label || field.fieldKey }}</div>
                <div class="fw-semibold">{{ field.fieldValue || '-' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="card shadow-sm border-0 h-100">
            <div class="card-body">
              <h5 class="mb-3">Documents</h5>

              <div *ngIf="!app.documents?.length" class="text-muted small">
                No documents submitted.
              </div>

              <div *ngFor="let doc of app.documents; trackBy: trackByDoc" class="border rounded p-3 mb-3">
                <div class="d-flex justify-content-between align-items-start gap-2">
                  <div>
                    <div class="fw-semibold">{{ doc.label || doc.documentTypeCode }}</div>
                    <div class="small text-muted">{{ doc.fileName }}</div>
                    <div class="small text-muted">{{ doc.mimeType }}</div>
                  </div>

                  <span class="badge" [ngClass]="getStatusClass(doc.status)">
                    {{ doc.status }}
                  </span>
                </div>

                <div *ngIf="doc.rejectionReason" class="small text-danger mt-2">
                  {{ doc.rejectionReason }}
                </div>

                <div class="mt-3">
                  <label class="form-label small">Document Review Notes</label>
                  <textarea class="form-control mb-2" rows="2" [(ngModel)]="documentReviewNotes[doc.id]"></textarea>

                  <label class="form-label small">Document Rejection Reason</label>
                  <textarea class="form-control mb-2" rows="2" [(ngModel)]="documentRejectReasons[doc.id]"></textarea>

                  <div class="d-flex gap-2">
                    <button class="btn btn-outline-success btn-sm" [disabled]="actionLoading"
                      (click)="approveDocument(doc)">
                      Approve
                    </button>

                    <button class="btn btn-outline-danger btn-sm" [disabled]="actionLoading"
                      (click)="rejectDocument(doc)">
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </ng-container>
    <div class="modal fade" id="reopenModal" tabindex="-1">

      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-warning">
            <h5 class="modal-title">
              Reopen Compliance Application
            </h5>
            <button class="btn-close" data-bs-dismiss="modal">
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning">
              <strong>
                This action will:
              </strong>
              <ul class="mb-0 mt-2">
                <li>Move the application back to Draft.</li>
                <li>Deactivate the user's compliance profile.</li>
                <li>Require the user to update and resubmit the application.</li>
                <li>Restart the compliance approval process.</li>
              </ul>
            </div>
            <label class="form-label">
              Reason
            </label>
            <textarea rows="4" class="form-control" [(ngModel)]="reopenReason"
              placeholder="Explain why the application is being reopened..."></textarea>
            <div class="form-check mt-3">
              <input class="form-check-input" type="checkbox" id="reopenConfirmed" [(ngModel)]="reopenConfirmed">

              <label class="form-check-label" for="reopenConfirmed">
                I understand that reopening this application will deactivate the user's
                compliance profile until the application is reviewed and approved again.
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button class="btn btn-warning" type="button"
              [disabled]="reopening || !reopenReason.trim() || !reopenConfirmed" (click)="reopenApplication()">
              <span *ngIf="reopening" class="spinner-border spinner-border-sm me-2">
              </span>
              {{ reopening ? 'Reopening...' : 'Reopen Application' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </main>
</div>